
jQuery(($) => {
    
    $('.card-collapse').on('click', function(e) {
        e.preventDefault();
        $(this).closest('details').prop('open', false);
      })
})